import React from "react";

const PublicFooter = () => {
    return (
        <footer className="public-footer mt-auto">
            <div className="container d-flex justify-content-between align-items-center">
                <div>&copy; 2025 UDPS AI - Sistem Aduan JAIS</div>
                <div>Selamat Datang ke Portal Rasmi Bahagian Penguatkuasaan JAIS</div>
            </div>
        </footer>
    );
};

export default PublicFooter;
